<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">单位名称</div>
          <div class="field">
            <el-input v-model.trim="query.comfullname" clearable></el-input>
          </div>
        </div>
         <div class="searchItem">
            <div class="label">业务员</div>
            <div class="field">
              <el-input v-model.trim="query.ptcname" clearable></el-input>
            </div>
          </div>
          <div class="searchItem">
            <div class="label">项目员</div>
            <div class="field">
              <el-input v-model.trim="query.cusername" clearable></el-input>
            </div>
          </div>
        <div class="searchItem">
          <div class="label">支付方式</div>
          <div class="field">
            <el-select
              v-model="query.paytype"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in paytypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">退回状态</div>
          <div class="field">
            <el-select
              v-model="query.psubzjreturnflg"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in returnList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目状态</div>
          <div class="field">
            <el-select
              v-model="query.projectstatus"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in projectStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">支付时间</div>
          <div class="field" style="width: 400px">
            <el-date-picker
              v-model="query.begTime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div style="margin: 0 10px">至</div>
            <el-date-picker
              v-model="query.endTime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button
              v-if="+query.comtype === 1"
              type="primary"
              @click="showButton = !showButton"
              >{{ showButton ? "收起" : "展开" }}</el-button
            >
          </div>
        </div>
      </div>
      <div>
        <el-collapse-transition v-if="+query.comtype === 1">
          <div v-show="showButton" style="padding: 10px">
            <el-radio-group v-model="areaid" @change="getPageList">
              <el-radio-button
                v-for="item in this.areaList"
                :key="item.dptareacode"
                :label="item.dptareacode"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <!-- <div class="search" >
      <el-radio-group v-model="radio" @change='change' class="search-box">
        <el-radio :label="1">线下支付</el-radio>
        <el-radio :label="2">线上支付</el-radio>
        <el-radio :label="3">全部</el-radio>
      </el-radio-group>
    </div> -->
    <vggrid
      :list="list"
      tableheight="600"
      flexname=""
      :cols="cols"
      :showfooter="false"
      :showPage="true"
      :resizable="true"
      :defaultPage="10"
      :total="query.total"
      @cellClick="cellClick"
      @cellDblClick="viewProject"
      @pagechange="pagechange"
      :isOperate="btn.isOperate"
      :operateBtn="btn.right"
      @vggridClick="vggridClick"
      :loading="loading"
    >
      <template slot="btn"> </template>
    </vggrid>
  </Container>
</template>
<script>
import request from "@/utils/request";
import MenuBtn from "../common/menuBtn";
import vggrid from "../common/vggrid";
import dayjs from "dayjs";
import utils from "../../assets/js/utils";
export default {
  name: "psuBzjfAffirmIndex",
  data() {
    return {
      menuid: this.$route.query.menuid,
      radio: 1,
      list: [],
      btn: {},
      btnLoading: false,
      paytypeList: [
        { label: "支付宝支付", value: "1" },
        { label: "微信支付", value: "2" },
        { label: "线下支付", value: "3" },
      ],
      returnList: [
        { label: "已退", value: "1" },
        { label: "未退", value: "0" },
      ],
      projectStatusList: [
        { label: "成功", value: "1" },
        { label: "失败", value: "0" },
      ],
      cols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 50,
        },
        {
          field: "projectcode",
          fieldtype: "C",
          title: "项目编号",
          calculExpr: "",
          addNewRowFlg: false,
        },
        // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false, width: 150},
        {
          field: "projectname",
          fieldtype: "C",
          title: "项目名称",
          calculExpr: "",
          addNewRowFlg: false,
          width: 200,
        },
        {
          field: "comfullname",
          fieldtype: "C",
          title: "供应商",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubzjamtdesc",
          fieldtype: "C",
          title: "保证金",
          calculExpr: "",
          addNewRowFlg: false,
        },
         {
          field: "ptcusername",
          fieldtype: "I",
          title: "业务员",
          calculExpr: "",
        },
        {
          field: "pusername",
          fieldtype: "I",
          title: "项目员",
          calculExpr: "",
        },
        // { field: 'psubzjusername', fieldtype: 'C', title: '支付人',calculExpr:'',addNewRowFlg: false},
        {
          field: "psubmpaytypedesc",
          fieldtype: "C",
          title: "支付方式",
          calculExpr: "",
          addNewRowFlg: false,
        },
        // { field: 'psubzjuserphone', fieldtype: 'C', title: '支付人联系',calculExpr:'',addNewRowFlg: false},
        {
          field: "psubzjpaytime",
          fieldtype: "C",
          title: "支付时间",
          calculExpr: "",
          addNewRowFlg: false,
        },
        // { field: 'psubzjpaycheckusername', fieldtype: 'C', title: '确认人',calculExpr:'',addNewRowFlg: false},
        // { field: 'psubzjpaychecktime', fieldtype: 'C', title: '确认时间',calculExpr:'',addNewRowFlg: false},
        // { field: 'psubzjreturnflgdesc', fieldtype: 'C', title: '退回状态',calculExpr:'',addNewRowFlg: false, width: 80},
        {
          field: "psuhtflg",
          fieldtype: "C",
          title: "合同",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psuconfirmfeeamt",
          fieldtype: "C",
          title: "服务费",
          calculExpr: "",
          addNewRowFlg: false,
        },
        // { field: 'psubidflgdesc', fieldtype: 'C', title: '是否中标',calculExpr:'',addNewRowFlg: false},
        {
          title: "操作 ",
          width: 80,
          showOverflow: true,
          slots: {
            default: "default",
            default: ({ row }) => {
              if (+row.psubzjpayflg !== 1) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.QRBZJ.bind(this, row)}
                  >
                    查看
                  </vxe-button>,
                ];
              } else if (+row.psubzjreturnflg !== 1 && +row.psubzjpaytype !== 3) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.ReturnBZJ.bind(this, row)}
                  >
                    退回
                  </vxe-button>,
                ];
              } else {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.QRBZJ.bind(this, row)}
                  >
                    查看
                  </vxe-button>,
                ];
              }
            },
          },
        },
      ],
      areaid: 0, //查询地区id
      showButton: true,
      areaList: [],
      psu: {},
      query: {
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        userid: this.$store.getters.loginUser.userid,
        total: 0,
        limit: 10,
        offset: 0,
      },
      loading: false
    };
  },
  created() {
    this.$on("CONFIRM", () => this.QRBZJ());
    this.$on("CLOSE", () => this.close());
  },
  activated() {
    this.init();
    this.getPageList();
    if (this.query.comtype === 1) {
      this.getareaList();
    }
  },
  mounted() {},
  watch: {},
  components: { MenuBtn, vggrid },
  methods: {
    btnClick(code) {
      this.$emit(code);
    },
    vggridClick(code, row) {
      this.psu = row;
      this.$emit(code, row);
    },
    async init() {},
    async viewProject(row) {
      this.psu = row.row;
      this.$router.push({
        name: "psuBzjAffirmForm",
        params: { psuid: this.psu.psuid, innerbtn: this.btn.inner, type: 3 },
      });
    },
    btnmenuclick(btn) {
      this.btn = btn;
    },
    async cellClick(row) {
      this.psu = row.row;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.loading = true
      this.getPageList();
    },
    async getPageList() {
      this.loading = true;
      this.query.cosid = this.$store.getters.loginUser.cosid;
      this.query.areaid = this.areaid;
      this.query.selectField = `projectcode,projectptccode,projectname,projecttime,
        projectid,projectstatus,projectisinvite,projectisqcheck,comfullname,
        psubzjpaychecktime,psubzjpaytime,psubzjpaytype,psubzjreturnflg,
        psubzjpayflg,psubzjamt,psuconfirmfeeamt,psuid,appendid,psufeepaytype,psufewreceive`;
      let res = await request({
        method: "get",
        url: "/cwgl/psuproject/getBZJPageList",
        params: this.query,
      });
      res.list.forEach((e) => {
        e.psubzjpaychecktime = utils.formatterDate(
          e.psubzjpaychecktime,
          "yyyy-MM-dd HH:mm:ss"
        );
        e.psubzjpaytime = utils.formatterDate(e.psubzjpaytime, "yyyy-MM-dd");
        if (+e.psubzjpaytype === 1 || +e.psubzjpaytype === 2) {
          e.psubzjpaycheckusername = "线上支付";
        }
        e.psubmpaytypedesc =
          +e.psubzjpaytype === 1
            ? "支付宝支付"
            : +e.psubzjpaytype === 2
            ? "微信支付"
            : +e.psubzjpaytype === 3
            ? "线下支付"
            : "";
        e.psubzjreturnflgdesc = +e.psubzjreturnflg === 1 ? "(已退)" : "(未退)";
        e.psuhtflg = e.appendid ? "已上传" : "";
        e.psubzjamtdesc = utils.comdify(e.psubzjamt) + e.psubzjreturnflgdesc;
        e.psubzjusername = e.psubzjusername
          ? e.psubzjusername + " " + e.psubzjuserphone
          : "";
        if (Number(e.psuconfirmfeeamt) > 0) {
          let psufeement = "(未付)";
          if (+e.psufeepaytype > 0 && +e.psufewreceive !== 2) {
            psufeement = "(待确认)";
          }
          if (+e.psufewreceive === 1) {
            psufeement = "(已付)";
          }
          e.psuconfirmfeeamt = utils.comdify(e.psuconfirmfeeamt) + psufeement;
        }
        if (e.psuconfirmfeeamt === null) {
          e.psuconfirmfeeamt = "";
        } else if (+e.psuconfirmfeeamt === 0) {
          e.psuconfirmfeeamt = "免费";
        }
        // if(+e.psubidflgcount > 0){
        //   if(+e.psubidflg === 1){
        //     e.psubidflgdesc = '中标'
        //   }
        //   else{
        //     e.psubidflgdesc = '未中标'
        //   }
        // } else{
        //     e.psubidflgdesc = '项目还未结束'
        // }
      });
      this.list = res.list;
      this.query.total = res.count[0].count;
      this.loading = false;
    },
    // async change(radio){
    //    this.query.paytype = radio
    //   this.getPageList()
    // },
    async QRBZJ(row) {
      this.psu = row;
      this.$router.push({
        name: "psuBzjAffirmForm",
        params: { psuid: this.psu.psuid, type: 1 },
      });
    },
    //获取地区list
    async getareaList() {
      let res = await request({
        method: "get",
        url: "/xtgl/dpt/getDptareaList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.areaList = res.filter((e) => {
        return +e.dptareause === 1;
      });
      this.areaList.unshift({
        dptareacode: 0,
        label: "全部",
      });
    },
    async search() {
      // this.radio = 3
      //  this.query.paytype = 3
      this.query.offset = 0;
      if (this.query.endTime) {
        this.query.endtime = dayjs(this.query.endTime)
          .add(1, "day")
          .format("YYYY-MM-D");
      }
      this.getPageList();
    },
    async ReturnBZJ(row) {
      this.psu = row;
      this.$router.push({
        name: "psuBzjAffirmForm",
        params: { psuid: this.psu.psuid, type: 1 },
      });
    },
  },
  filters: {},
};
</script>
<style lang="scss">
.search-box {
  margin-left: 20px;
}
</style>
